<h2 class="mat-h2">{{ title }}</h2>
<p class="mat-body-2">{{ description }}</p>
<p class="mat-subtitle-2">{{ subText }}</p>
<p class="mat-body-2">{{ descriptionSecondParagraph }}</p>

<div class="actions">

    <div class="cancel">
        <button mat-button
            mat-stroked-button
            id="change-dialog-cancel"
            (click)="cancel()">
            {{ 'default.cancel' | blah | uppercase }}
        </button>
    </div>
    <div class="confirm">
        <button mat-button
            mat-flat-button
            color="accent"
            id="change-dialog-confirm"
            [type]="'raised'"
            (click)="confirm()">
            {{ okButtonText | blah | uppercase }}
        </button>
    </div>
</div>